import React, { useEffect } from "react"
import {api} from "../../utils/api";
import {BigLoading} from "../../components/BigLoading";

export const OAuth = (props) => {
    // console.log("props",props)
    useEffect(() => {
      const code = window.location.search.slice(6);
      //console.log("code", code)
      if (code) {
        api.getToken(code)
          .then(() => {
            window.location = sessionStorage.getItem('path')
            sessionStorage.removeItem('path')
          });
      }
    }, [props.code])

    return <div className="layout-center full-height"><BigLoading /></div>
}

